import React from "react";
import styled, { keyframes } from "styled-components";
// Spin animation
const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

// Container for the spinner
const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px; /* Full screen */
  background-color: transparent; /* Cream background */
`;

// Outer spinning ring
const SpinnerRing = styled.div`
  width: 120px;
  height: 120px;
  border: 8px solid #FCFAF2;
  border-top: 8px solid #767462ff; /* Forest green */
  border-radius: 50%;
  animation: ${spin} 1.5s linear infinite;
  display: flex;
  justify-content: center;
  align-items: center;
`;

// Logo inside the spinner
const SpinnerLogo = styled.img`
  width: 100px;
  height: auto;
  border-radius: 50%;
`;

const LoadingSpinner = () => {
  return (
    <SpinnerContainer>
      <SpinnerRing>
        <SpinnerLogo src={'https://spencer-w-mathews.github.io/rainbowtroutreverie_images/images/logo.png'} alt="Logo" />
      </SpinnerRing>
    </SpinnerContainer>
  );
};

export default LoadingSpinner;